import { Injectable, inject } from '@angular/core';
import { UUID } from '@okcargo-apps/shared-domain';
import { MarkBatchImportAsCheckedCommandHandler } from '@okcargo/command-processor';
import { BaseCommandRepository } from '../command-repository/command.repository';
import { transformFromIMarkBatchImportAsCheckedCommand } from './batch-import-command.mapper';

@Injectable({ providedIn: 'root' })
export class BatchImportCommandService {
  private readonly markBatchImportAsCheckedCommandHandler: MarkBatchImportAsCheckedCommandHandler;

  constructor() {
    const commandRepository = inject(BaseCommandRepository);

    this.markBatchImportAsCheckedCommandHandler = new MarkBatchImportAsCheckedCommandHandler(commandRepository);
  }

  public async markBatchImportAsChecked(id: UUID): Promise<void> {
    const command = transformFromIMarkBatchImportAsCheckedCommand(id);
    return this.markBatchImportAsCheckedCommandHandler.handle(command);
  }
}
